function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import sprintf from 'sprintf-js';
import { translate } from 'shared/helper/translate/util';
import { setHeading } from '../actions';

/**
 * This component is useful for updating a page heading and setting the `<title>` attribute of a page
 * You can use this on any react-based page in the following manner...
 * <IdentifyPage title="The html title" heading="The page heading" />
 */
var IdentifyPage = function IdentifyPage(_ref) {
  var _ref$bodyClassName = _ref.bodyClassName,
    bodyClassName = _ref$bodyClassName === void 0 ? '' : _ref$bodyClassName,
    description = _ref.description,
    heading = _ref.heading,
    keywords = _ref.keywords,
    robots = _ref.robots,
    setHeading = _ref.setHeading,
    siteTitle = _ref.siteTitle,
    t = _ref.t,
    title = _ref.title;
  var _useState = useState(document.body.className),
    _useState2 = _slicedToArray(_useState, 1),
    defaultBodyClassName = _useState2[0];
  useEffect(function () {
    // document.getElementsByTagName('title')[0].innerHTML = pageTitle(title);
    setHeading(heading || null);
    setMetaTag('description', description);
    setMetaTag('keywords', keywords);

    // Not translated, `robots` is a fixed set of crawler directives
    if (robots) {
      getMetaElement('robots').content = robots;
    }
    return function () {
      // document.getElementsByTagName('title')[0].innerHTML = pageTitle();
      setHeading(null);
      document.body.className = defaultBodyClassName;

      // Leaving the directive in place would apply it to every page visited afterwards
      if (robots) {
        var el = document.querySelector('meta[name=robots]');
        if (el) {
          el.remove();
        }
      }
    };
  }, []);
  useEffect(function () {
    if (bodyClassName) {
      document.body.className = "".concat(defaultBodyClassName, " ").concat(bodyClassName);
    }
  }, [bodyClassName]);
  var getMetaElement = function getMetaElement(metaTag) {
    var el = document.querySelector("meta[name=".concat(metaTag, "]"));
    if (el) {
      return el;
    }
    el = document.createElement('meta');
    el.name = metaTag;
    document.querySelector('head').appendChild(el);
    return el;
  };
  var pageTitle = function pageTitle() {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return sprintf.sprintf(siteTitle, translate(title, {}, t));
  };
  var setMetaTag = function setMetaTag(metaTag, content) {
    if (content) {
      getMetaElement(metaTag).content = translate(content, {}, t);
    }
  };
  return null;
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var application = _ref2.application;
  return {
    //     // siteTitle: application.config.siteTitle,
    //     t: application.translations,
  };
};
export default connect(mapStateToProps, {
  setHeading: setHeading
})(IdentifyPage);